export enum HttpSymbolKind {
  request = 'request',
  requestLine = 'requestLine',
  requestHeader = 'requestHeader',
  requestBody = 'requestBody',
  response = 'response',
  gql = 'gql',
  proto = 'proto',
  script = 'script',
  metaData = 'metaData',
  comment = 'comment',

  url = 'url',
  operator = 'operator',
  key = 'key',
  value = 'value',
  variable = 'variable',
  path = 'path',
  variableDefinition = 'variableDefinition',
  text = 'text',
}
